<template>
  <div class="my-account bg-grey h-100">
    <NavbarMain />
    <div class="row mx-xl-5 mx-md-4 mx-0 my-3 h-auto">
      <NavbarAccount class="col-xl-auto col-md-12 col-12 h-100" />
      <div class="col-xl col-md-12 px-0">
        <div class="bg-white p-5 shadow-sm container-xl">
          <h4 class="mb-5">Datos de cuenta</h4>
          <div class="pl-4">
            <div class="row">
              <div class="col-4">
                <b>Nombre de usuario:</b>
              </div>
              <div class="col-6">{{ auth.username }}</div>
            </div>
            <hr />
            <div class="row">
              <div class="col-4">
                <b>E-mail:</b>
              </div>
              <div class="col-6">{{ user.email }}</div>
            </div>
            <hr />
            <div class="row">
              <div class="col-4">
                <b>Contraseña:</b>
              </div>
              <div class="col-6">
                <span>*********</span>
                <a href="https://www.sistemaapple.com.mx/password" class="ml-1"
                  >Cambiar contraseña</a
                >
              </div>
            </div>
            <hr />
            <div class="row">
              <div class="col-4">
                <b>Fecha de creación:</b>
              </div>
              <div class="col-6">{{ user.creationDate.slice(0, 10) }}</div>
            </div>
            <hr />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import NavbarMain from "@/components/NavbarMain.vue";
import NavbarAccount from "@/components/account/NavbarAccount.vue";
import Api from "../../tools/Api2";
export default {
  name: "MyProfile",
  components: {
    NavbarMain,
    NavbarAccount,
  },
  data() {
    return {
      user: {
        creationDate: "",
        email: "",
      },
    };
  },
  computed: {
    ...mapState(["auth"]),
  },
  created: async function () {
    Api("user")
      .get(this.auth.id)
      .then((res) => {
        this.user = res.user;
        let data = new Date(res.user.creationDate);
        this.user.creationDate = `${data.getDate()}/${
          data.getMonth() + 1
        }/${data.getFullYear()}`;
      });
  },
};
</script>

<style lang="scss" scoped>
footer {
  position: absolute;
}

.text-secondary a {
  color: #172b46 !important;
  font-weight: bold;
}
</style>
